module.exports = __webpack_public_path__ + "static/heroes-bg-9e4296c011c3f2e3144b855466511193.jpg";